import React, { useState } from 'react';
import PopUp from '../Popup/PopUp';
import BtnSubmit from '../Buttons/BtnSubmit';
import Config from '../../../Config';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import Image from "../Image/image";
import cellcomLogoTemp from './images/cellcomLogoTemp.svg';
import iconsCareLeave from './images/icons-care-leave.svg';
import {getDataFromIContentRepo} from '../../../utilities/StringHelpers/StringHelpers';

const SalesHeader = props => {
  const [showLobbyPopup, setShowLobbyPopup] = useState(false);
  const [headerPopupAppearancesCount, setHeaderPopupAppearancesCount] = useState(0);
  const ignoreListTVAndCellular = ['welcomePage', 'productsPage', 'newNumberPage', 'chooseNumberPage', 'successPage'];
  const ignoreListFiber = ['addressFormPage', 'welcomePage', 'otpVerifyPhone', 'otpVerifyCode', 'successPage'];

  const siteLogo = getDataFromIContentRepo('siteLogo');
  const cellcomLogoUrl = Config.epiBaseUrl + siteLogo?.url;

  const goToLobby = () => {
    window.location.href = Config.staticWebSiteUrl;
  };

  const isShowPopup = () => {
    if (headerPopupAppearancesCount > 2) {
      goToLobby();
    } else {
      if (isRedirect()) {
        goToLobby();
      } else {
        setShowLobbyPopup(true);
        setHeaderPopupAppearancesCount(headerPopupAppearancesCount + 1);
      }
    }
  };

  const isRedirect = () => {
    if (props.saleType != 'internet') {
      if (ignoreListTVAndCellular.includes(props.currentPage)) {
        return true;
      }
    } else {
      if (ignoreListFiber.includes(props.currentPage)) {
        return true;
      }
    }
  };

  return <div className='cellcom-header'>
     <img src={cellcomLogoUrl} alt='logo' className='cellcom-header__temp-logo'  onClick={() => isShowPopup()}/>
      <div>
        <PopUp showPopUp={showLobbyPopup} onClose={() => setShowLobbyPopup(false)}>
          <div className='popup_content'>
            <h1 className='title'>מה, כבר נגמר?</h1>
            <div className='icon_leave' style={{backgroundImage:iconsCareLeave.bg()}}>
          </div>
            <h5 className='leave_text'>
              בטוח שאתם רוצים לצאת?<br></br>אם תרצו להשלים את ההצטרפות בהמשך, תצטרכו להתחיל מחדש.
              <br></br>
              יש לכם שאלה, אנחנו זמינים ב-
              {isMobile ? <a className='service-phone' href='tel:*2426'>
                  2426*
                </a> : <span>2426*</span>}
            </h5>
            <BtnSubmit onclick={() => setShowLobbyPopup(false)} text='חזור לתהליך'></BtnSubmit>
            <div className='leave_link' onClick={() => goToLobby()}>
              לעמוד הבית
            </div>
          </div>
        </PopUp>
      </div>
    </div>;
};

const mapStateToProps = state => ({
  currentPage: state.saleBlock.page,
  saleType: state.saleBlock.saleType
});

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(SalesHeader);